module.exports = __webpack_public_path__ + "static/media/token-logo.8c44c221.png";